import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
// import required modules
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade } from 'swiper/modules';
import './slider.css'
import Modal from '../Modal';
import { logAudioClick, SECTIONS } from '../../utils/contentConsumption';
const Slider = ({ sliders }) => {
    // console.log(sliders);
    // return
    const userId = localStorage.getItem('dastaan__user_id');
    const plan_active = localStorage.getItem('dastaan__plan_active');
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const navigate = useNavigate()
    const openAudioFile = (audio_file_id) => {
        logAudioClick(audio_file_id, SECTIONS.HOME_SLIDER);
        navigate(`/audio-file-detail/${audio_file_id}`);
    };
    return (
        <>
      
            <Swiper
                slidesPerView={1}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    1024: {
                        // slidesPerView: 'auto',
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                }}
                navigation
                // pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                loop={true}
                autoplay={{ delay: 1500 }}
                effect="fadeIn"
                fadeEffect={{ crossFade: true }}
                modules={[Pagination, Navigation,
                    Scrollbar,
                    A11y,
                    Autoplay,
                    EffectFade
                ]}
                className={`mySwiper ${dw > 768 ? 'ml-10' : 'mt-15'} `}
            >
                {/*  mt-6  */}
                {sliders.map((slider, index) => (
                    <SwiperSlide key={index}>
                        <div className="slide-content" 
                            onClick={() => (userId !== null && plan_active === 'true') ? openAudioFile(slider.id) : (userId !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                            style={{
                                backgroundImage: `url('${slider.slider_image}')`,
                            }}>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <Modal show={showModal} onClose={() => setShowModal(false)} />
        </>
    );
}
export default Slider